'use strict';
import axios from 'axios';
import store from 'components/store.js';

//Fetching the data from store.
const GetCustomerQueryParams = () => {

    const state = { ...store.getState() };//avoid bugs with immutable data
    const UserId = parseInt(state.userid);
    const RoleId = parseInt(state.roleId);
    const AccessToken = state.accessToken;

    const queryParams = {
      "role_id": RoleId,
      "user_id": UserId,
      "access_token": AccessToken
    };
    return queryParams;
  }

/*************************************************************************/
/*              APIs for Licenses
*************************************************************************/

export const getLicenses = () => {
    let urlstr = `/api/customers/admin/licenses/all`;
    let queryParams = GetCustomerQueryParams();
    let dataQuery = Object.assign(queryParams); 
    return  axios.get(urlstr, 
        {
          headers: {
            'Content-Type': 'application/json',
            data: JSON.stringify(dataQuery)
          }
        })
        .then(resp => resp.data.payload);
}

export const getLicensesHistory = () => {
    let urlstr = `/api/customers/admin/licenses/history/all`;
    let queryParams = GetCustomerQueryParams();
    let dataQuery = Object.assign(queryParams); 
    return  axios.get(urlstr, 
        {
          headers: {
            'Content-Type': 'application/json',
            data: JSON.stringify(dataQuery)
          }
        })
        .then(resp => resp.data.payload);
}

export const getLicenseHistoryByCustomerId = (customerId) => {
    let urlstr = `/api/customers/admin/licenses/history/${customerId}`;
    let queryParams = GetCustomerQueryParams();
    let dataQuery = Object.assign(queryParams); 
    return  axios.get(urlstr, 
        {
          headers: {
            'Content-Type': 'application/json',
            data: JSON.stringify(dataQuery)
          }
        })
        .then(resp => resp.data.payload);
}

export const updateCustomerLicense = (customer_id, licenseData) => {
    let urlstr = `/api/customers/admin/licenses/update/${customer_id}`;
    let queryParams = GetCustomerQueryParams();
    let dataQuery = Object.assign(queryParams);
    return  axios.post(urlstr, licenseData,
        {
            headers: {
                'Content-Type': 'application/json',
                data: JSON.stringify(dataQuery),
            }
        })
        .then(resp => resp.data.payload);
  }

